import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../../../constants';

const GenericLabResultsQuestions = [
  {
    label:
      'Please submit your lab results as a PDF file or a clear photo (image) of your results.',
    field: 'genericBloodTest_labResults',
    type: 'file_upload',
    extras: { sendToBeluga: false },
    accepts: ['application/pdf', ...IMAGE_TYPES],
    isLast: true,
    answer: [
      {
        resourceId: 'genericBloodTest_labResults',
        buttonLabel: 'Upload lab results'
      }
    ]
  }
] as const;

export type GenericLabResultsQuestionAnswerFields = Partial<
  QuestionAnswerMap<typeof GenericLabResultsQuestions>
>;

export default GenericLabResultsQuestions;
